import * as React from "react";
import SearchResult from "../../_data/models/SearchResult";
import {OrderedMap} from "immutable";
import {SearchView} from "../reducers";
import SearchTrendingContainer from "../containers/SearchTrendingContainer";
import LoadingIndicatorComponent from "../../_widgets/loadingIndicator/LoadingIndicatorComponent";
import SearchResultContainer from "../containers/SearchResultContainer";
import ReduxInfiniteScroll from "redux-infinite-scroll";
import Meta from "../../_data/models/Meta";

interface Props {
    loading: boolean;
    loadingMessage: string;
    results: OrderedMap<number, SearchResult>;
    view: SearchView;
    noResultsFound: boolean;
    meta: Meta;
    loadMore: (meta: Meta) => void;
}

const SearchComponent = (props: Props) => {
    const {loading, loadingMessage, results, view, noResultsFound, meta, loadMore} = props;

    if (loading)
        return (
            <div>
                <LoadingIndicatorComponent message={loadingMessage}/>
            </div>
        );

    if (view == SearchView.TRENDING)
        return (
            <div>
                {noResultsFound &&
                <div className="row">
                    <div className="large-12 columns">
                        <div>No results found for this location. Try again or check out these suggestions.</div>
                    </div>
                </div>
                }
                <SearchTrendingContainer results={results}/>
            </div>
        );

    return (
        <div className="row">
            <ReduxInfiniteScroll
                holderType="ul"
                className="list-block flex-container"
                loadMore={() => loadMore(meta)}
                elementIsScrollable={false}
                loadingMore={loading}
                loader={<LoadingIndicatorComponent/>}
                threshold={200}>
                {
                    results.toArray().map(r => {
                        return <SearchResultContainer result={r} key={r.id}/>
                    })
                }
            </ReduxInfiniteScroll>
        </div>
    );
};
export default SearchComponent;


// WEBPACK FOOTER //
// ./app/client/search/components/SearchComponent.tsx